import React from "react";
import "./RoundedTag.scss";

const RoundedTag = ({ value }) => {
  return <div className="tag">{value}</div>;
};

export default RoundedTag;
